import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { downloadBlob } from 'modules/core/lib/download'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import app from 'modules/core/store/models/app'

import { AttachmentDownloadPageDocument } from 'generated/resources/graphql'

const AttachmentDownloadPage = () => {
  const { id } = useParams<{ id: string }>()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { data, loading, error } = useQuery(AttachmentDownloadPageDocument, {
    variables: { id: id ?? '' },
    fetchPolicy: 'no-cache',
    skip: !id,
  })

  const attachmentUrl = data?.notifications?.notificationAttachment?.url
  const attachmentFilename = data?.notifications?.notificationAttachment?.filename
  const hasError = !!error
  const isLoading = loading
  const notFound = !isLoading && !hasError && !attachmentUrl
  const dashboardPath = navigation.dashboard.fullPath()

  useEffect(() => {
    if (hasError || notFound) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('notifications.attachment_download.error'),
      })
      navigate(dashboardPath, { replace: true })
      return
    }

    if (!attachmentUrl || !attachmentFilename) return

    const downloadFile = async () => {
      try {
        const response = await fetch(attachmentUrl)

        if (!response.ok) {
          throw new Error('Download failed')
        }

        const blob = await response.blob()
        downloadBlob(blob, attachmentFilename)
        app.setFlash({
          type: 'correct',
          message: i18n.t('notifications.attachment_download.success'),
        })
      } catch {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('notifications.attachment_download.error'),
        })
      } finally {
        navigate(dashboardPath, { replace: true })
      }
    }

    downloadFile()
  }, [attachmentUrl, attachmentFilename, hasError, notFound, dashboardPath, navigate])

  return (
    <Box height="full" justifyContent="center" alignItems="center">
      <Spinner />
    </Box>
  )
}

export default AttachmentDownloadPage
